<template>
  <div>
    <!--Subscribe section start-->
    <section>
      <div class="container">
        <div class="row">
          <div class="col-md-8 offset-md-2">
            <div class="footer-text">
              <img :src='"../assets/images/email.png"' alt="email">
              <h2 class="title text-center md-margin-top">Hear about our newest <span>games</span></h2>
              <p> We are continuously creating new Escape Rooms and Alexa Skills for you to enjoy. Sign up to get notified when we have new content!</p>
              <form target="_blank" method="post" action="https://stokedskills.us18.list-manage.com/subscribe/post?u=b62be5f9ed859c9d5b8c25ae5&amp;id=4d0c825464" class="footer-form">
                <div class="form-group">
                  <!--<input type="EMAIL" id="mce-EMAIL" class="form-control" required placeholder="enter your email">-->
                  <input class="form-control" name="EMAIL" id="mce-EMAIL" placeholder="Your email address:" type="email" required="required" >
                </div>
                <div class="form-button">
                  <button type="submit"  class="btn btn-custom theme-color">send</button>
                </div>
              </form>



            </div>
          </div>
        </div>
      </div>
    </section>
    <!--Subscribe section Ends-->
  </div>
</template>
<script>
export default {
  name: 'Subscribe'
}
</script>



// WEBPACK FOOTER //
// src/components/subscribe.vue